import PropTypes from "prop-types";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import AddToHomeScreenIcon from "@mui/icons-material/AddToHomeScreen";
import CloseIcon from "@mui/icons-material/Close";
import IosShareIcon from "@mui/icons-material/IosShare";

const safariSteps = [
  "Toque no botão de compartilhar do Safari.",
  "Selecione Adicionar à Tela de Início.",
  "Confirme tocando em Adicionar.",
];

const IosInstallInstructionsModal = ({
  clubName,
  isSafari,
  onClose,
  open,
}) => {
  const resolvedClubName = clubName || "clube";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      aria-labelledby="ios-install-title"
    >
      <DialogTitle id="ios-install-title" sx={{ pr: 6, fontWeight: 800 }}>
        Instalar app do {resolvedClubName}
        <IconButton
          aria-label="Fechar instruções de instalação"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {isSafari ? (
          <Stack spacing={1.5}>
            <Typography variant="body2" color="text.secondary">
              No iPhone ou iPad, adicione o app pela tela de compartilhamento.
            </Typography>
            <Stack spacing={1}>
              {safariSteps.map((step, index) => (
                <Stack
                  key={step}
                  direction="row"
                  spacing={1.2}
                  alignItems="flex-start"
                >
                  <Box
                    sx={{
                      width: 28,
                      height: 28,
                      borderRadius: "50%",
                      bgcolor: "primary.main",
                      color: "primary.contrastText",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 800,
                      flexShrink: 0,
                    }}
                  >
                    {index + 1}
                  </Box>
                  <Typography variant="body2" sx={{ pt: 0.45 }}>
                    {step}
                  </Typography>
                </Stack>
              ))}
            </Stack>
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 1,
                p: 1.25,
                bgcolor: "background.default",
              }}
            >
              <IosShareIcon color="primary" />
              <AddToHomeScreenIcon color="primary" />
              <Typography variant="caption" color="text.secondary">
                Procure por Adicionar à Tela de Início na lista do Safari.
              </Typography>
            </Stack>
          </Stack>
        ) : (
          <Stack spacing={1.5}>
            <Typography variant="body2" color="text.secondary">
              O iOS permite adicionar o app à tela inicial pelo Safari.
            </Typography>
            <Typography variant="body2">
              Abra esta aplicação no Safari e use a opção Adicionar à Tela de
              Início no menu de compartilhamento.
            </Typography>
          </Stack>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          fullWidth
          sx={{ textTransform: "none", fontWeight: 800 }}
        >
          Entendi
        </Button>
      </DialogActions>
    </Dialog>
  );
};

IosInstallInstructionsModal.propTypes = {
  clubName: PropTypes.string,
  isSafari: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

export default IosInstallInstructionsModal;
